import { IBillingCommon } from "./common";
import { IBillingUser } from "./user";

export enum BillingUser {
  Common = "common",
  Casting = "casting",
  CastingIpc = "castingIpc",
  Performer = "performer",
  Graduate = "graduate",
  GraduateTransfer = "graduate-transfer",
  PerformerChange = "performer-change",
  YoungPerformer = "young-performer",
  JoiningCasting = "joining-casting",
  JoiningPerformer = "joining-performer",
  JoiningYoungPerformer = "joining-young-performer",
  JoiningGraduate = "joining-graduate",
}

export type BillingUserWithoutCommon = Exclude<BillingUser, BillingUser.Common>;

export const billingUserMap = {
  [BillingUser.Common]: "common",
  [BillingUser.Casting]: "Casting",
  [BillingUser.CastingIpc]: "CastingIpc",
  [BillingUser.Performer]: "Performer",
  [BillingUser.Graduate]: "Graduate",
  [BillingUser.GraduateTransfer]: "Graduate",
  [BillingUser.YoungPerformer]: "Young Performer",
  [BillingUser.JoiningCasting]: "Casting",
  [BillingUser.JoiningPerformer]: "Performer",
  [BillingUser.JoiningYoungPerformer]: "Young Performer",
  [BillingUser.JoiningGraduate]: "Graduate",
  [BillingUser.PerformerChange]: "Performer",
};

export interface IBillingFallbacks {
  [BillingUser.Common]: IBillingCommon;
  [BillingUser.Casting]: IBillingUser;
  [BillingUser.CastingIpc]: IBillingUser;
  [BillingUser.Performer]: IBillingUser;
  [BillingUser.Graduate]: IBillingUser;
  [BillingUser.GraduateTransfer]: IBillingUser;
  [BillingUser.YoungPerformer]: IBillingUser;
  [BillingUser.JoiningCasting]: IBillingUser;
  [BillingUser.JoiningPerformer]: IBillingUser;
  [BillingUser.JoiningYoungPerformer]: IBillingUser;
  [BillingUser.JoiningGraduate]: IBillingUser;
}
